// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format7 } from '../../constants';

import { format2 } from '../../constants';

/** Iceland */
const IS: PhoneNumberData = [354, 'IS', 7, format7, 9, format2];

export default IS;
